<template>
  <div>
    <v-btn       
      color="success"
      @click.stop="drawer = true"
    >
      Manage Job Requirements
    </v-btn>
    <v-navigation-drawer
      v-model="drawer"      
      app
      right
      width="850"
      temporary
    >
      <v-toolbar
        color="success" 
        dark
      >
        <v-toolbar-title class="white--text">
          <v-avatar
            tile
          >
            <V-img :src="grade.image_url" />       
          </v-avatar>   
          {{ `${position.name} (${grade.pivot.name} - Rank ${grade.value})` }}
        </v-toolbar-title>
      </v-toolbar>
      <v-container>
        <v-row>
          <v-col>     
            <v-card>
              <v-card-actions>
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="search"
                      append-icon="search"
                      label="Search by description"
                      single-line
                      hide-details
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                    offset-md="3"
                  >
                    <setup-positions-job-requirements-dialog-create
                      :position="position"
                      :grade-id="grade.pivot.id"
                      @created="loadData"
                    />  
                  </v-col>
                  <v-col cols="12">
                    <v-autocomplete
                      :items="tags"    
                      :loading="loadingTags"     
                      placeholder="Filter by tags"
                      item-text="name"
                      item-value="id"
                      color="primary"
                      hide-no-data
                      hide-selected
                      clearable
                      multiple
                      chips
                      deletable-chips
                      @change="filter"
                    />
                  </v-col>
                </v-row>
              </v-card-actions>
             
              <v-data-table
                :headers="headers"
                :items="filteredJobRequirements"
                :loading="loading"
                :search="search"
                fixed-header
                hide-default-header
                height="700px"
              >
                <template v-slot:item="props">
                  <tr>
                    <td class="py-2">
                      <p>{{ props.item.job_requirement.job_description.value }}</p>
                      <div>
                        <v-chip 
                          v-for="tag in props.item.job_requirement.job_description.tags" 
                          :key="tag.id"
                          color="primary"
                          label
                          outlined
                          small
                          class="mx-1"
                        >
                          {{ tag.name }}
                        </v-chip>
                      </div>
                    </td>
                    <td>                   
                      <v-row 
                        class="horizontal-scroll-xl"
                      >     
                        <span 
                          v-for="skillLevel in props.item.skill_levels"                            
                          :key="skillLevel.id"
                          class="pa-2 text-center"
                        >
                          <v-hover v-slot:default="{ hover }">
                            <div>
                              <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                  <v-avatar
                                    size="30"
                                    tile
                                    v-on="on" 
                                  >
                                    <img
                                      :src="skillLevel.skill.image_url"
                                      alt="skill logo"
                                    >
                                    <div v-show="hover">
                                      <setup-positions-job-requirements-popover-menu                                      
                                        :requirement-id="skillLevel.position_job_requirement_id"
                                        :skill-level="skillLevel"
                                        @deleted="loadData"
                                        @updated="loadData"
                                      />
                                    </div>
                                  </v-avatar>
                                </template>
                                {{ skillLevel.skill.name }}
                              </v-tooltip>
                              <v-rating     
                                :value="skillLevel.level"                     
                                :length="skillLevel.level"
                                class="pt-1"
                                size="15"
                                readonly
                              />                                       
                            </div>
                          </v-hover>
                        </span>
                      </v-row>
                    </td>
                    <td>
                      <v-card-actions>
                        <setup-positions-job-requirements-dialog-add
                          :position-id="position.id"
                          :grade-id="grade.pivot.id"
                          :job-description-id="props.item.job_requirement.job_description_id"
                          @added="loadData"
                        />
                      
                        <setup-positions-job-requirements-dialog-delete
                          :position-id="position.id"
                          :grade-id="grade.pivot.id"
                          :job-description-id="props.item.job_requirement.job_description_id"
                          @deleted="loadData"
                        />
                      </v-card-actions>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card>     
          </v-col>
        </v-row>
      </v-container>
    </v-navigation-drawer>
  </div>
</template>

<script>
  export default {
    components: {
      SetupPositionsJobRequirementsDialogCreate: () => import('@/components/setup/positions/job-requirements/DialogCreate'),
      SetupPositionsJobRequirementsPopoverMenu: () => import('@/components/setup/positions/job-requirements/PopoverMenu'),
      SetupPositionsJobRequirementsDialogAdd: () => import('@/components/setup/positions/job-requirements/DialogAdd'),
      SetupPositionsJobRequirementsDialogDelete: () => import('@/components/setup/positions/job-requirements/DialogDelete'),
    },
    props: {
      position: {
        type: Object,
        required: true,
      },
      grade: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        search: '',
        drawer: null,
        loading: false,
        loadingTags: false,
        tags: [],
        tagFilterIds: [],
        jobRequirements: [],
        headers: [
          {
            text: 'Description',
            align: 'left',
            sortable: false,
            value: 'job_requirement.job_description.value',
            width: '50%',
          },
          {
            text: 'Skills',
            align: 'left',
            sortable: false,
            filterable: false,
            value: 'skill',
            width: '30%',
          },
          {
            text: 'Actions',
            align: 'center',
            sortable: false,
            filterable: false,
            value: 'action',
          },
        ],
      }
    },
    computed: {
      filteredJobRequirements () {
        return this.jobRequirements.filter(jobRequirement => {
          // get job descriptions that match the tags filter 
          if (this.tagFilterIds.length > 0) {
            let tagIds = jobRequirement.job_requirement.job_description.tags.map(tag => tag.id)

            return _.intersection(this.tagFilterIds, tagIds).length > 0
          }        

          return true
        })
      },
    },

    watch: {
      drawer: function (value) {
        if (value) {
          this.loadData()
          this.loadTags()
        } else {
          this.tagFilterIds.splice(0, this.tagFilterIds.length)

          this.$resetData()
        }
      },
    },
    methods: {
      loadData () {
        this.loading = true

        this.$api.positionJobRequirements().list(this.position.id, this.grade.pivot.id)
          .then(response => {
            this.jobRequirements = this.groupJobDescriptions(response.data)
            this.loading = false
          })
      },
      loadTags () {
        this.loadingTags = true

        this.$api.tags().list()
          .then(response => {
            this.tags = response.data

            this.loadingTags = false
          })
      },
      filter (ids) {
        this.tagFilterIds.splice(0, this.tagFilterIds.length)
        this.tagFilterIds = ids
      },

      // filter (value, search, item) {
      //   const upperCaseSearch = search.toUpperCase()

      //   return value != null &&
      //     search != null &&
      //     typeof value === 'string' &&
      //     (value.toString().toUpperCase().indexOf(upperCaseSearch) !== -1)
      // },
      groupJobDescriptions (requirements) {
        return requirements.reduce((accumulator, requirement) => {
          let index = accumulator.findIndex(item => item.job_requirement.job_description_id === requirement.job_requirement.job_description_id)
        
          let requirementCopy = { ...requirement }
          let skillLevel = { ...requirementCopy.skill_level }
        
          delete requirementCopy.skill_level
          delete requirementCopy.skill_level_id

          if (index === -1) {
            accumulator.push({ ...requirementCopy, skill_levels: [ { ...skillLevel, position_job_requirement_id: requirement.id } ] })
          } else {
            accumulator[index].skill_levels.push({ ...skillLevel, position_job_requirement_id: requirement.id })
          }

          return accumulator
        }, [])
      },
    },
  }
</script>

<style lang="css" scoped>
::v-deep .v-rating .v-icon{
  padding:0px;
}

::v-deep .v-rating {
  width:80px;
}
  
::v-deep .v-table__overflow{
  overflow-x: hidden;
}

.horizontal-scroll-xl{
  overflow-x:hidden; 
  overflow-y:hidden; 
  width:15vw;
}
</style>
